// ECF - contact form app - custom select JS
document.addEventListener("DOMContentLoaded", () => {

    const waitForForm = setInterval(() => {

        const select = document.querySelector("#what_can_we_help_you_with");
        if (select && !select.nextElementSibling?.classList.contains("custom-dropdown-wrapper")) {
            createCustomDropdown(select);
        }

        const select2 = document.querySelector("#whats_your_monthly_revenue");
        if (select2 && !select2.nextElementSibling?.classList.contains("custom-dropdown-wrapper")) {
            createCustomDropdown(select2);
        }

        if (select && select2) {
            clearInterval(waitForForm);
        }

    }, 100);
});


function createCustomDropdown(originalSelect) {

    originalSelect.style.display = "none";

    const wrapper = document.createElement("div");
    wrapper.className = "custom-dropdown-wrapper";

    const selectedDiv = document.createElement("div");
    selectedDiv.className = "cd-selected";
    //selectedDiv.textContent = originalSelect.options[0].text;
    const label = document.querySelector(`label[for="${originalSelect.id}"]`);
    selectedDiv.textContent = label ? label.textContent : originalSelect.options[0].text;

    const list = document.createElement("ul");
    list.className = "cd-options";

    Array.from(originalSelect.options).forEach((opt, index) => {

        const li = document.createElement("li");
        li.textContent = opt.text;
        li.dataset.value = opt.value;

        // Make first option active by default
        /*if (index === 0) {
            li.classList.add("active");
        }*/

        list.appendChild(li);
    });

    originalSelect.insertAdjacentElement("afterend", wrapper);
    wrapper.appendChild(selectedDiv);
    wrapper.appendChild(list);

    // Toggle dropdown
    selectedDiv.addEventListener("click", () => {
        selectedDiv.classList.toggle("open");
        list.classList.toggle("open");
    });

    // Option click
    list.querySelectorAll("li").forEach(li => {
        li.addEventListener("click", () => {

            // Remove active from all
            list.querySelectorAll("li").forEach(item => {
                item.classList.remove("active");
            });

            // Add active to clicked
            li.classList.add("active");

            selectedDiv.textContent = li.textContent;
            originalSelect.value = li.dataset.value;

            // 👉 ADD THIS LOGIC
            if (originalSelect.id === "what_can_we_help_you_with") {

                const val = li.dataset.value.toLowerCase();

                const el1 = document.querySelector(".Contact_drawer_mainside_bottom_success_inner_bottom_1_new");
                const el2 = document.querySelector(".Contact_drawer_mainside_bottom_success_inner_bottom_2_new");

                // Remove active from both first
                el1?.classList.remove("active");
                el2?.classList.remove("active");

                if (val === "website" || val === "cro") {
                    el1?.classList.add("active");
                } else if (val === "branding" || val === "other") {
                    el2?.classList.add("active");
                }
            }

            selectedDiv.classList.remove("open");
            list.classList.remove("open");
        });
    });

    // Close when clicking outside
    document.addEventListener("click", e => {
        if (!wrapper.contains(e.target)) {
            selectedDiv.classList.remove("open");
            list.classList.remove("open");
        }
    });
}